import { useState, useEffect, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

//components
import { toast } from "react-toastify";
import { FaFolderOpen } from "react-icons/fa";
import { Spinner, Row } from "react-bootstrap";
import { ListContent } from "../favorites-list/styles";
import { Modal } from "../../../../components/modal";
import { LinksTable } from "../../../manager/components/table-links";
import { PaginationList } from "../../../../components/pagination";

//services
import {
	listMyLinks,
	changeStatusLink,
	deleteLink,
	listLinkLeaves,
} from "../../../../services/favorites.service";
import UsuarioContext from "../../../../../context/userContext/context";
import { subscription } from "../../../../services/login/login.service";
import { useLocalStorage } from "react-use";
import { ISubscription } from "../../../../models/ISubscriptionDetails";
import UpgradePlan from "../../../../components/copy-button/upgrade-plan";
import { useRecoilState } from "recoil";
import { subscriptionState } from "../../../../../hooks/atoms/subscriptions";

export const MyLinks = (props: any): JSX.Element => {
	const { listFilter, handlePageChange, setTotalLinks } = props;
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);

	// const [, setSubscriptionDetails] = useLocalStorage<ISubscription | {}>('subscription', {})
	const [subscriptionDetails, setSubscriptionDetails] = useRecoilState(subscriptionState)

	//Pagination
	const [totalItens, setTotalItens] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);

	//Ordering
	const [sortOrder, setSortOrder] = useState(1);
	const [sortField, setSortField] = useState("name");

	const [loading, setLoading] = useState<boolean>(true);
	const [loadingModal, setLoadingModal] = useState<boolean>(false);
	const [showInactiveMaterial, setShowInactiveMaterial] =
		useState<boolean>(false);
	const [showRemoveLinkModal, setShowRemoveLinkModal] =
		useState<boolean>(false);
	const [links, setLinks] = useState<any[]>([]);
	const [link, setLink] = useState<any>();

	const [expandedKeys, setExpandedKeys] = useState({});

	const treeTableConfig = [
		{
			field: "title",
			nameTemplate: true,
			header: "Nome",
			sortable: true,
			style: { textAlign: "left", width: "35%" },
		},
		{
			field: "type",
			className: "d-none-lg-table d-none-md-table d-none-xs-table",
			header: "Tipo",
			typeTemplate: true,
			sortable: true,
			style: { width: "12%", textAlign: "center" },
		},
		{
			field: "code",
			className: "d-none-md-table d-none-xs-table",
			header: "Código",
			sortable: true,
			codeTemplate: true,
			style: { width: "12%", textAlign: "center" },
		},
		{
			field: "knowledge_area",
			className: "d-none-xs-table",
			knowledgesTemplate: true,
			header: "Áreas de Conhecimento",
			sortable: true,
			style: { width: "18%", textAlign: "center" },
		},
		{
			field: "external_access",
			className: "d-none-xs-table",
			header: "Acessos Externos",
			sortable: true,
			style: { width: "12%", textAlign: "center" },
		},
		{
			field: "actions",
			header: "",
			actionsTemplate: true,
			sortable: false,
			style: { textAlign: "center", width: "7%" },
		},
	];

	useEffect(() => {
		getLinksList(listFilter);
	}, [listFilter]);

	const getLinksList = (filters?: any) => {
		setLoading(true);
		listMyLinks(filters)
			.then((resp: any) => {
				if (filters && filters.page) {
					setCurrentPage(filters.page);
				}
				setTotalItens(resp.count);
				setTotalLinks(resp.count);
				setLinks(treatNodes(resp.results));
			})
			.finally(() => {
				setLoading(false);
			});
	};

	/**
	 * Trata a resposta da API para o formato esperado pela ProductsTreeTable
	 * @param infos campo results da resposta da API
	 * @returns nodes prontos para a TreeTable
	 */
	const treatNodes = (infos: any) => {
		let nodes: any = [];

		infos.map((node: any, index: number) => {
			let n = {
				key: node.key,
				data: node.data,
				leaf: !node.data.leaf,
			};

			nodes.push(n);
		});

		return nodes;
	};

	/**
	 * Lazy-load dos itens da tabela de materiais do cliente, disparado quando um node é "aberto"
	 */
	const handleTableNodeExpanded = (event: any) => {
		setExpandedKeys({ ...expandedKeys, [event.node.key]: true });

		if (!event.node.children) {
			setLoading(true);

			listLinkLeaves(
				event.node.data.type.toLowerCase(),
				event.node.data.id
			)
				.then((response: any) => {
					let children: any = treatNodes(response);
					let list = links;

					if (event.node.data.type === "Discipline") {
						//Acha o index do event.node --- Se o node for um children e não estiver na lista principal da pagina,
						//findIndex sempre retorna -1, ocorrendo em um bug de duplicação do node
						let i = list.findIndex(
							(no) => no.key === event.node.key
						);

						list[i].children = children;
						setLinks(list);
					} else if (
						event.node.data.type === "Item" ||
						event.node.data.type === "Theme"
					) {
						const findNode = list.findIndex(
							(node) => node.key === event.node.key
						);

						if (findNode >= 0) {
							list[findNode].children = children;
						} else {
							// Adiciona as children no event.node
							event.node.children = children;
						}
					}

					setLinks(list);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	};

	const handleViewLink = (event?: any) => {
		switch (event.data.type) {
			case "Discipline":
				window.open(`/disciplines/${event.data.id}`, "_blank");
				break;

			case "Item":
				window.open(`/unity/${event.data.id}`, "_blank");
				break;

			case "Theme":
				window.open(`/themes/${event.data.id}`, "_blank");
				break;

			case "Media":
				window.open(`/objects/${event.data.id}`, "_blank");
				break;
		}
	};

	const handleChangeStatusLink = (event?: any) => {
		if (event.data.is_active) {
			setLink(event.data);
			setShowInactiveMaterial(true);
		} else {
			changeStatusLink(
				event.data.id,
				user.id,
				!event.data.is_active,
				event.data.type
			)
				.then(() => {
					toast.success("Status alterado com sucesso!");
					getLinksList(listFilter);
					handleGetSubscription();
				})
				.catch((err) => {
					if(err.response.data.message === 'Essa ação ultrapassa o limite do plano'){
						toast.warning(<UpgradePlan onUpgrade={() => { window.open('https://dstoreconteudos.com.br/#planos', '_blank') }} />, {
									autoClose: false,
									icon: false,
									pauseOnFocusLoss: false,
									style: { width: 375, right: 50}
								})
					}else{
						toast.success(
							"Ocorreu um erro ao alterar o status este link. Tente novamente."
						);
					}
					
				});
		}
	};

	const handleGetSubscription = () => {
		subscription().then((res: any) => {
			setSubscriptionDetails(res)
		})
	}

	const handleDeleteLink = (event?: any) => {
		setLink(event.data);
		setShowRemoveLinkModal(true);
	};

	const submitChangeStatusLink = () => {
		setLoadingModal(true);
		changeStatusLink(link.id, user.id, !link.is_active, link.type)
			.then(() => {
				toast.success("Status alterado com sucesso!");
				getLinksList(listFilter);
				setShowInactiveMaterial(false);
				setLoadingModal(false);
				handleGetSubscription();
			})
			.catch((err) => {
				if(err.response.data.message === 'Essa ação ultrapassa o limite do plano'){
					toast.warning(<UpgradePlan onUpgrade={() => { window.open('https://dstoreconteudos.com.br/#planos', '_blank') }} />, {
								autoClose: false,
								icon: false,
								pauseOnFocusLoss: false,
								style: { width: 375, right: 50}
							})
				}else{
					toast.success(
						"Ocorreu um erro ao alterar o status este link. Tente novamente."
					);
				}
			});
	};

	const submitDeleteLink = () => {
		setLoadingModal(true);
		deleteLink(link.id, user.id, link.is_active, link.type)
			.then(() => {
				toast.success("Link removido com sucesso!");
				getLinksList(listFilter);
				setShowRemoveLinkModal(false);
				setLoadingModal(false);
			})
			.catch(() => {
				toast.success(
					"Ocorreu um erro ao remover este link. Tente novamente."
				);
			});
	};

	const handleTableSort = (event: any) => {
		let order =
			event.sortOrder > 0 ? event.sortField : "-" + event.sortField;

		setSortOrder(event.sortOrder);
		setSortField(event.sortField);


		getLinksList({ ...listFilter, page: 1, ordering:order });
	};

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	return (
		<Row>
			<ListContent>
				{links.length === 0 ? (
					<div className="text-center text-grey mt-5">
						<FaFolderOpen className="mt-5" size={100} />
						<h5>{translation("favorites.emptyLinks")}</h5>
					</div>
				) : (
					<LinksTable
						treeFields={treeTableConfig}
						nodes={links}
						sortField={sortField}
						sortOrder={sortOrder}
						handleTableSort={handleTableSort}
						handleViewLink={handleViewLink}
						handleChangeStatusLink={handleChangeStatusLink}
						handleDeleteLink={handleDeleteLink}
						onExpand={handleTableNodeExpanded}
						expandedKeys={expandedKeys}
					/>
				)}
			</ListContent>

			<Row className="mt-4">
				{!loading && links.length > 0 ? (
					<PaginationList
						currentPage={currentPage}
						totalItems={totalItens}
						onPageChange={handlePageChange}
					/>
				) : (
					<></>
				)}
			</Row>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("manager.user.inactivate")}
				show={showInactiveMaterial}
				onHide={() => setShowInactiveMaterial(false)}
				onSubmit={submitChangeStatusLink}
				variant="confirm-modal-default"
				loading={loadingModal}
			>
				<p>
					Tem certeza que deseja inativar o link do material{" "}
					<b className="span-ellipsis">{link ? link.title : ""}</b>?
				</p>
				<p>Todos os links vinculados a este também serão inativados.</p>
			</Modal>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("manager.links.remove")}
				show={showRemoveLinkModal}
				onHide={() => setShowRemoveLinkModal(false)}
				onSubmit={submitDeleteLink}
				variant="confirm-modal"
				loading={loadingModal}
			>
				<p>
					Tem certeza que deseja excluir o link do material{" "}
					<b className="span-ellipsis">{link ? link.title : ""}</b>?
				</p>
				<p>Para utilizá-lo novamente você deverá gerar um novo link.</p>
			</Modal>
		</Row>
	);
};
